import { Box, Modal } from "@mui/material";
import { useContext, useState } from "react";
import { UserContext } from "../../../../../../App";
import useGetDevice from "../../../hooks/useGetDevice";

const CustomErrorModal = ({ customErrorOpenModal, handleCloseCustomErrorModal, productName }) => {
  const [showSolution, setShowSolution] = useState(false);
  const { color} = useContext(UserContext);
  const isMobile = useGetDevice();

  const handleToggleSolution = () => {
    setShowSolution(!showSolution);
  };

  return (
    <Modal open={customErrorOpenModal} onClose={handleCloseCustomErrorModal}>
      <Box
        className={`custom-error-modal-wrapper ${showSolution ? "show-solution" : ""}`}
        sx={{
          backgroundColor: color === "dark" ? "#353a50" : "#fff",
          color: color === "dark" ? "white" : "black",
          position: isMobile ? "static" : "relative",
          width: isMobile ? "100%" : "40%",
          maxWidth: "100vw",
          maxHeight: isMobile ? "100%" : "90%",
          transform: isMobile ? "none" : "translate(50%, -50%)",
          borderRadius: "10px",
          top: "50%",
          left: "15%",
          overflowY: "auto",
          ...(isMobile && {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }),
        }}
      >
        <h2 className="error-custom-text">Error code 401 Inventory/active batch not found </h2>
        <h5 className="solution-error-custom-text">{`Sorry we are not able to add ${productName} to the cart`}</h5>

        <ul className="custom-error-ui">
          {showSolution && (
            <>
              <li>
                Step 1: Identify the Scanned Product - Review details of the scanned product to
                gather information about the missing inventory.
              </li>
              <li>
                Step 2: Access Pallet ROS Website - Open your web browser in the console and
                navigate to "www.palletnow.co".
              </li>
              <li>
                Step 3: Log In to Pallet ROS Account - If you have an account, log in using your
                credentials.
              </li>
              <li>
                Step 4: Navigate to Product Module - Once logged in, find and enter the "Product"
                module on the Pallet ROS website.
              </li>
              <li>
                Step 5: Go to Inventory Section - Within the Product module, navigate to the
                "Inventory" section.
              </li>
              <li>
                Step 6: Search for the Scanned Product - Search for the missing product using the
                search bar in the Inventory section.
              </li>

              <li>
                Step 7: Edit Product Details or Use Express PO - Use an "Edit" option to update the
                product's inventory with the correct quantity. (or) - Alternatively, if there's an
                "Express PO" feature, use it to initiate the inventory update process.
              </li>

              <li>
                Step 8: Verify Product Availability for Billing - After updating the inventory,
                check the product's availability for billing.
              </li>
              <li>
                Step 9: Save Changes - Save any edits made to the product details or submit the
                Express PO to complete the inventory update process.
              </li>
              <li>
                Step 10: Confirm Inventory Update - Double-check the inventory section to confirm
                that the scanned product is now available in your ROS.
              </li>
            </>
          )}
        </ul>
        <button className="custom-error-btn" onClick={handleToggleSolution}>
          {showSolution ? "View Less" : "View More"}
        </button>
      </Box>
    </Modal>
  );
};

export default CustomErrorModal;
